<template>
  <div class="upload-preview">
    <div
      v-for="(item, index) in files"
      :key="index"
      class="upload-preview__item"
    >
      <removable-entry truncate @close="$emit('remove', item.uploadedFileKey)">
        {{ item.name }}
      </removable-entry>
    </div>
  </div>
</template>

<script>
// @flow

import RemovableEntry from './RemovableEntry.vue'

export default {
  components: {
    RemovableEntry
  },
  props: {
    files: {
      type: Array, // Array<{ name: string, uploadedFileKey: string }>
      default: () => []
    }
  }
}
</script>

<style src="./upload-preview.scss" />
